import {
  biUploadExpiredText,
  biUploadFailureText,
} from '@euler/app/components/message/widgets/bi-upload/functions/biUploadPhase';
import {
  BiDatasetPermission,
  BiDatasetVisibility,
  BiUploadedDatasetView,
} from '@euler/model/bi/dataset';
import { BiUploadStatus, BiUploadView } from '@euler/model/bi/upload';
import { biTimeLabel } from '../../functions/biDashboardText';

export const kBiDatasetVisibilityTags: Record<BiDatasetVisibility, string> = {
  [BiDatasetVisibility.Private]: '私有',
  [BiDatasetVisibility.Store]: '门店可用',
};

export const kBiDatasetGrantLabels: Record<BiDatasetPermission, string> = {
  [BiDatasetPermission.Use]: '可使用',
  [BiDatasetPermission.Manage]: '可管理',
};

/** Where a dataset is used, e.g. `用在 2 个看板（3 张图表）`. */
export function biDatasetUsageText(dataset: BiUploadedDatasetView): string {
  const { dashboardCount, cardCount } = dataset.usage;
  return dashboardCount
    ? `用在 ${dashboardCount} 个看板（${cardCount} 张图表）`
    : '还没有用在看板上';
}

/** Rows and columns, the file it came from, and when. */
export function biDatasetSourceText(dataset: BiUploadedDatasetView): string {
  return [
    `${dataset.rowCount.toLocaleString('zh-CN')} 行 · ${
      dataset.columnCount
    } 列`,
    dataset.ownerName
      ? `${dataset.ownerName} 上传于 ${biTimeLabel(dataset.createdAt)}`
      : `上传于 ${biTimeLabel(dataset.createdAt)}`,
  ].join(' · ');
}

/** An upload still in progress, or failed, in words. */
export function biUploadStateText(upload: BiUploadView): string {
  switch (upload.status) {
    case BiUploadStatus.Failed:
      return biUploadFailureText(upload.failure);
    case BiUploadStatus.Expired:
      return biUploadExpiredText(upload);
    case BiUploadStatus.NeedsSheetSelection:
      return '等待选择工作表';
    case BiUploadStatus.Uploaded:
      return '正在读取';
    default: {
      const waiting = upload.sheets.some(
        sheet => sheet.upload?.status === BiUploadStatus.NeedsConfirmation,
      );
      return waiting ? '等待确认列' : '正在导入';
    }
  }
}
